import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-behavior-info-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="mode !== 'view'" class="mb-24">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{ behaviorCategoryName }}
        </h3>
      </div>
      <h4 class="title s-16 mb-16">Behavior</h4>
      <div class="behavior-badge-wrapper">
        <span class="badge" *ngFor="let type of behaviorTypes">
          {{ type.behaviorTypeName }}
        </span>
      </div>
    </div>
  `,
})
export class BehaviorInfoCardComponent {
  @Input() mode?: string;
  @Input() behaviorCategoryName?: string;
  @Input() behaviorTypes?: { behaviorTypeName: string }[];
}
